import DateFnsUtils from '@date-io/date-fns';
import { Fade, Modal } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import axios from 'axios';
import koLocale from 'date-fns/locale/ko';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { throttle } from 'lodash';
import moment from 'moment';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { withTranslation } from 'react-i18next';
import Ratio from 'react-ratio';
import { Link } from 'react-router-dom';
import Store from 'store';
import { ChoiseFileModal } from '../../../_utils/ai-event-modal';
import apiClient from '../../../_utils/axios';
import { getBigModalWidh, getModalWidh } from '../../../_utils/modalWidh';
import images from '../../../assets';
import { ConvertBtn, ConvertBtnEach } from '../../../components/ai_generate/generateDetailView';
import { CheckBox, CheckMark, InputGroup, InputPad, inputStyle } from '../../../components/auth/login';
import {
  HorizontalSp,
  HSLine,
  MediaQuery,
  ModalNorBtn,
  ModalTitle,
  NorButton,
  VerticalSp,
} from '../../../components/Common';
import {
  BodyCell,
  CustomBody,
  CustomCell,
  CustomeSelect,
  CustomHead,
  DetailItem,
  DItemCost,
  DItemCostMobile,
  DItemDowndTxt,
  DItemText,
  DItemTitle,
  HeadCell,
  ModalBlockLbl,
  ModalBody,
  ModalCell,
  ModalContents,
  ModalHead,
  ModalHisCell,
  ModalPurTitle,
  PdfDownBtn,
  PurOptionButton,
  PurTabButton,
  ReceiptBtn,
  ReceiptBtnMobile,
  ReceiptDesItem,
  TextFieldComp,
} from '../../../components/mypage/AIGeneratePurchase';
import { CheckBoxChecker } from '../../../components/mypage/AIGenerateResult';
import { GoodCell } from '../../../components/mypage/GoodsList';
import { TitleBlock } from '../../../components/mypage/Mypage';
import { BorderBtn } from '../../../components/mypage/Purchase';
import Pagenation from '../../../components/Pagenation';
import { banks } from '../../../json/bankCode';
import { CONFIG_MESSAGE } from '../../../libs/config';
import '../Picker.scss';
import '../Table.scss';
import { getCurrentLang, getStringByLang } from '../../../libs/lang';
import { CURRENCY_CONFIG } from '../../../libs/common';

// --- 헬퍼 함수 (중복 로직 제거) ---
const getCurrencySymbol = (currency) => {
  const lang = getCurrentLang();
  return CURRENCY_CONFIG[lang].symbol;
};

/**
 * 컴포넌트 내에서 조건부로 렌더링되던 JSX 텍스트들을 객체로 관리합니다.
 * JSX를 값으로 직접 사용하기 때문에 strong, br 태그 등을 그대로 활용할 수 있습니다.
 */
export const translationData = {
  // 구매내역 상단 경고 문구
  purchaseWarning: {
    kr: (
      <p>
        디자인 파일 특성상&nbsp;<strong>파일 다운로드 후</strong> 또는 <strong>환불 유효기간 (7일) 이내</strong>{' '}
        다운로드를 받지 않을 경우 <br />
        상품이 <strong>자동으로 구매 확정</strong>되며 구매확정된 상품은 <strong>환불이 불가능</strong>
        합니다.
        <br />
        페이팔 결제 환불시 페이팔 수수료 5% 차감 후 환불됩니다.
      </p>
    ),
    en: (
      <p>
        Once you download designs or If you don't download within <strong>effective date (7 days)</strong>, <br />
        <strong>purchase is automatically confirmed and no refund.</strong>
        <br />
        When refunding a PayPal payment, 5% of the PayPal fee will be deducted before the refund.
      </p>
    ),
    jp: (
      <p>
        デザインファイルの特性上、<strong>ファイルのダウンロード後</strong>または
        <strong>払い戻し有効期間（7日）以内</strong>にダウンロードされなかった場合、商品は
        <strong>自動的に購入確定</strong>となり、購入確定後の商品は<strong>払い戻しできません</strong>。
        <br />
        PayPalで決済された場合の払い戻しは、5%のPayPal手数料を差し引いた金額となります。
      </p>
    ),
  },
  // 모바일용 구매내역 상단 경고 문구
  purchaseWarningMobile: {
    kr: (
      <p style={{ fontSize: 12 }}>
        디자인 파일 특성상&nbsp;<strong>파일 다운로드 후</strong> 또는 <strong>환불 유효기간 (7일) 이내</strong> <br />
        다운로드를 받지 않을 경우 상품이 <strong>자동으로 구매 확정</strong>되며 <br />
        구매확정된 상품은 <strong>환불이 불가능</strong>합니다.
        <br />
        페이팔 결제 환불시 페이팔 수수료 5% 차감 후 환불됩니다.
      </p>
    ),
    en: (
      <p>
        Once you downloaed designs or <br />
        If you don't download within <strong>effective date (7 days)</strong>, <br />
        <strong>purchase is automatically confirmed and no refund.</strong>
        <br />
        When refunding a PayPal payment, <br />
        5% of the PayPal fee will be deducted before the refund.
      </p>
    ),
    jp: (
      <p style={{ fontSize: 12 }}>
        デザインファイルの特性上、<strong>ファイルのダウンロード後</strong>または
        <strong>払い戻し有効期間（7日）以内</strong>に<br />
        ダウンロードされなかった場合、商品は<strong>自動的に購入確定</strong>となり、
        <br />
        購入確定後の商品は<strong>払い戻しできません</strong>。
        <br />
        PayPalで決済された場合の払い戻しは、5%のPayPal手数料を差し引いた金額となります。
      </p>
    ),
  },
  // 환불 요청 모달 안내 문구
  refundInfo: {
    kr: (
      <>
        <div
          style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: 'black', textAlign: 'center', wordBreak: 'keep-all' }}
        >
          유효기간 7일 이내에 미 다운로드 디자인 파일인 경우 환불을 요청하면 관리자 확인 후 7 영업일 이내 환불이
          진행됩니다.
        </div>
        <div
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 16,
            color: 'black',
            textAlign: 'center',
            wordBreak: 'keep-all',
            maxWidth: 330,
            margin: 'auto',
          }}
        >
          7일이 지나도 환불이 안될 경우 운영자에게 메일로 문의해주시기 바랍니다.
        </div>
      </>
    ),
    en: (
      <>
        <div
          style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: 'black', textAlign: 'center', wordBreak: 'keep-all' }}
        >
          In case of designs files not downloaded within 7 days,
          <br />
          refund will be made within 7 business days.
        </div>
        <div
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 16,
            color: 'black',
            textAlign: 'center',
            wordBreak: 'keep-all',
            maxWidth: 330,
            margin: 'auto',
          }}
        >
          If refund is not made after 7 days, please contact administrator via email.
        </div>
      </>
    ),
    jp: (
      <>
        <div
          style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: 'black', textAlign: 'center', wordBreak: 'keep-all' }}
        >
          有効期間（7日）以内にダウンロードされなかったデザインファイルの場合、払い戻しを要請されますと、管理者確認後、7営業日以内に払い戻しが行われます。
        </div>
        <div
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 16,
            color: 'black',
            textAlign: 'center',
            wordBreak: 'keep-all',
            maxWidth: 330,
            margin: 'auto',
          }}
        >
          7日を過ぎても払い戻しが行われない場合は、管理者までメールにてお問い合わせください。
        </div>
      </>
    ),
  },
};

class GeneratePurchaseList extends React.Component {
  state = {
    tabindex: 0, //0:결제내역, 1:환불내역
    monthtype: 3,
    startDate: '',
    endDate: '',
    ditemopen: false,
    receiptmodal: false,
    refundmodal: false,
    reasontype: '',
    reasontxt: '',
    list: [],
    lockList: [],
    page: 1,
    total_pages: 0,
    receiptTarget: 0,
    refundOrder: '',
    checkboxArray: [],
    checkboxListArray: [],
    convertingArray: [],
    downloadingArray: [],
    amount_products: 0,
    childWidthSize: 0,
    checkboxRefWidth: 0,
    invoiceWidth: 0,
    invoiceDetailWidth: 0,
    orderAmountRefWidth: 0,
    designFileWidth: 0,
    downloadFileChoiceModalState: false, // 이벤트라 나중에 지워야함
    downloadFileChoice: null, // 이벤트라 나중에 지워야함
    selectOrderId: null, // 이벤트라 나중에 지워야함
    selectProductId: null, // 이벤트라 나중에 지워야함
  };
  constructor(props) {
    super(props);
    this.throttledDownload = throttle(this.downloadSelectedImage, 2000); // 2초 간격으로 쓰로틀링
  }

  componentDidMount = async () => {
    await this.setStateAsync({
      monthtype: 3,
      startDate: moment().subtract(3, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    });
    this.getList(1);
  };

  getPaymentMethodText = (payMethod, lang) => {
    const texts = {
      card: { kr: '카드결제: 엑심베이', en: 'Paid in Full with Credit Card (ref: Eximbay)', jp: 'カード決済: Eximbay' },
      paypal: { kr: '페이팔결제: 페이팔', en: 'Paid in Full with Paypal (ref: Paypal)', jp: 'ペイパル決済: Paypal' },
      credit: { kr: '크레딧 결제', en: 'Paid in Full with Credit Point', jp: 'ポイント決済' },
      default: { kr: '기타 결제 방법', en: 'Other payment method', jp: 'その他の支払い方法' },
    };

    const methodText = texts[payMethod] || texts.default;
    return methodText[lang] || methodText.en;
  };

  componentDidUpdate(prevProps, prevState) {
    const prevConvertingArray = prevState.convertingArray;
    const currentConvertingArray = this.state.convertingArray;
  }

  // 3초에 1번씩 요청 보내서 상태 확인하고 버튼 바꿔주는 기능
  convertStateChecker() {
    if (!this.interval) {
      this.interval = setInterval(async () => {
        const currentConvertingArray = this.state.convertingArray;
        currentConvertingArray.forEach(async (item) => {
          // 각 요소에 대한 작업 수행
          const res = await apiClient.get(`/generate/convert/${item}`);
          if (res.data.data.is_convert === true) {
            const newConvertingArray = this.state.convertingArray.filter(
              (item) => parseInt(item) !== res.data.data.product_id,
            );
            this.getList(this.state.page);
            this.setState({ convertingArray: newConvertingArray });
            if (isMobile) {
              this.downloadImageMobile([res.data.data.product_id], res.data.data.order_no);
            } else {
              this.downloadImage(
                `${process.env.REACT_APP_S3_BUCKET_DOMAIN}/${res.data.data.ai_generate.res_img_path}`,
                res.data.data.product_id,
                'jpg',
              );
              this.downloadImage(
                `${process.env.REACT_APP_S3_BUCKET_DOMAIN}/${res.data.data.ai_generate.res_psd_path}`,
                res.data.data.product_id,
                'psd',
              );
            }
          } else {
            this.setState({
              convertingArray: this.state.convertingArray.map((item) => {
                if (item[0] === res.data.data.ai_generate.product_id) {
                  return [item[0], res.data.data.convert_step]; // item[1] 값을 newValue로 수정
                }
                return item; // 조건에 맞지 않으면 기존 값을 그대로 유지
              }),
            });
          }
        });
        if (currentConvertingArray < 1) {
          clearInterval(this.interval);
        }
      }, 3000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleStartDateChange = (date) => {
    this.setState({ startDate: moment(date).format('YYYY-MM-DD') });
  };

  labelStartCalendar = (date, invalidLabel) => {
    const { startDate } = this.state;
    if (startDate === '') {
      return '';
    } else {
      var month = date.getMonth() + 1 + '';
      var day = date.getDate() + '';
      var years = date.getFullYear() + '';
      return years + '.' + month.padStart(2, '0') + '.' + day.padStart(2, '0');
    }
  };

  labelEndCalendar = (date, invalidLabel) => {
    const { endDate } = this.state;
    if (endDate === '') {
      return '';
    } else {
      var month = date.getMonth() + 1 + '';
      var day = date.getDate() + '';
      var years = date.getFullYear() + '';
      return years + '.' + month.padStart(2, '0') + '.' + day.padStart(2, '0');
    }
  };

  handleEndDateChange = (date) => {
    this.setState({ endDate: moment(date).format('YYYY-MM-DD') });
  };

  onCloseReceiptModal = () => {
    this.setState({ receiptmodal: false });
  };

  onCloseRefundModal = () => {
    this.setState({ refundmodal: false });
  };

  onShowRefundModal = () => {
    this.setState({ refundmodal: true });
  };

  onShowChildComponent = () => {
    this.setState({ refundmodal: true });
  };

  onCloseDownloadFileChoiceModal = () => {
    this.setState({ downloadFileChoiceModalState: false, selectOrderId: null, selectProductId: null });
  };

  onDownloadFileChoice = (type) => {
    this.setState({ downloadFileChoice: type, downloadFileChoiceModalState: false }, () => {
      // setState가 완료된 후에 실행될 코드
      if (this.state.selectOrderId) {
        this.downloadImagesSet(this.state.selectOrderId, null);
      } else {
        this.downloadImageOne(this.state.selectProductId, null);
      }
    });
  };

  setList = async (productIndex, index, convertPercent) => {
    const newList = [...this.state.list];
    newList[index] = {
      ...newList[index],
      order_products: [...newList[index].order_products],
    };
    newList[index].order_products[productIndex].convertPercent = convertPercent;
    await this.setStateAsync({ list: newList });
  };

  getList = async (page) => {
    const startDate = this.state.startDate;

    const endDate = this.state.endDate;
    let is_refund = this.state.tabindex;
    let searchDate = '';

    if (startDate !== '' && endDate !== '') {
      searchDate = `${startDate}~${endDate}`;
    }
    const res = await apiClient.get(
      `/generate/order?page=${page}&size=8&is_refund=${is_refund}&searchDate=${searchDate}`,
    );

    if (res) {
      this.setState({
        list: res.data.data,
        page: res.data.page,
        total_pages: res.data.total_pages,
        amount_products: res.data.data.reduce((total, order) => total + order.order_products.length, 0),
      });
      res.data.data.map((item) => {
        item.order_products.map((products) => {
          if (products.is_download === true && products.is_convert === false) {
            const currentConvertingArray = this.state.convertingArray;
            // 전체 변환이지만, 개별 변환이 진행 중일 때에는 개별 빼고 나머지 변환 요청. ex) 0, 1, 2, 3 중에 2번 상품 변환 중일 때 -> 2번 뺴고 0, 1, 3 변환
            const included = currentConvertingArray.map((item) => parseInt(item)).includes(products.product_id);
            if (!included) {
              const newConvertingArray = [
                ...currentConvertingArray,
                [products.product_id.toString(), products.convert_step],
              ];
              this.setState({ convertingArray: newConvertingArray });
            }
            this.convertStateChecker();
          }
        });
      });
    }
  };

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  downloadImageMobile = async (products_id, order_no) => {
    let filename;

    products_id.forEach((downloadingProductId) => {
      const addData = [downloadingProductId, 0];
      const currentDownloadingArray = this.state.downloadingArray;
      const newDownloadingArray = [...currentDownloadingArray, addData];
      this.setState({ downloadingArray: newDownloadingArray });
    });

    if (order_no.includes('AI-')) {
      filename = order_no.replace('AI-', '');
    } else {
      filename = order_no;
    }

    try {
      const download = await apiClient.get(
        `${process.env.REACT_APP_API_URL}/generate/download/zip/${products_id}?x-access-token=${Store.get(
          'accessToken',
        )}`,
        {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            const percentComplete = (progressEvent.loaded / progressEvent.total) * 100;
          },
        },
      );

      // 파일 다운로드를 위해 Blob을 사용하여 URL을 생성합니다.
      const url = window.URL.createObjectURL(new Blob([download.data]));

      // a 태그를 만들어 다운로드 링크를 설정합니다.
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `AI-${filename}.zip`); // 다운로드될 파일의 이름을 설정합니다.
      document.body.appendChild(link);

      // 클릭 이벤트를 발생시켜 다운로드를 시작합니다.
      link.click();

      // 필요에 따라 다운로드 후 URL을 해제합니다.
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading ZIP file:', error);
      // 오류 처리
    }
    products_id.forEach((downloadingProductId) => {
      const currentDownloadingArray = this.state.downloadingArray;
      const newDownloadingArray = currentDownloadingArray.filter((item) => item[0] !== downloadingProductId);
      this.setState({ downloadingArray: newDownloadingArray });
    });
  };

  /**
   * url을 받아서 이미지를 다운로드하는 함수
   * @param {stirng} url
   */

  downloadImage = async (url, downloadingProductId, img) => {
    try {
      // downloadingArray 안에 product_id 설정. 다운로드 시, jpg & psd가 받아짐. psd가 용량이 더 커서 일반적으로 psd를 진행도
      if (img === 'psd') {
        const addData = [downloadingProductId, 0];
        const currentDownloadingArray = this.state.downloadingArray;
        const newDownloadingArray = [...currentDownloadingArray, addData];
        this.setState({ downloadingArray: newDownloadingArray });
      }

      // HTTP GET 요청 보내고 응답 받기
      const response = await axios.get(url, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          if (img === 'psd' && progressEvent.lengthComputable) {
            const percentComplete = (progressEvent.loaded / progressEvent.total) * 100;
            const currentDownloadingArray = this.state.downloadingArray;
            const newDownloadingArray = currentDownloadingArray.map((item) => {
              if (item[0] === downloadingProductId) {
                // 해당하는 ID를 가진 항목의 두 번째 값을 업데이트합니다.
                return [downloadingProductId, percentComplete.toFixed(2)];
              }
              return item;
            });
            // 상태를 업데이트합니다.
            this.setState({ downloadingArray: newDownloadingArray });
          }
        },
      });

      // Blob을 URL.createObjectURL을 사용하여 다운로드 가능한 링크로 변환
      const imageUrl = URL.createObjectURL(response.data);

      // 다운로드 링크 생성
      const downloadLink = document.createElement('a');
      const urlParts = url.split('/');
      downloadLink.href = imageUrl;
      downloadLink.download = urlParts[urlParts.length - 1]; // 파일 이름 설정
      downloadLink.click();

      // 사용이 끝난 URL 해제
      // URL.revokeObjectURL(imageUrl);

      if (img === 'psd') {
        const currentDownloadingArray = this.state.downloadingArray;
        const newDownloadingArray = currentDownloadingArray.filter((item) => item[0] !== downloadingProductId);
        this.setState({ downloadingArray: newDownloadingArray });
      }
    } catch (error) {
      console.error('다운로드 중 오류가 발생했습니다:', error);
    }
  };

  /**
   * 체크박스에 체크된 상품을 서버에 보내서 다운로드 url을 받아와 다운로드하는 함수
   */
  downloadSelectedImage = async () => {
    const { checkboxArray } = this.state;
    checkboxArray.forEach((checkbox) => {
      this.downloadImageOne(checkbox);
    });
    this.setState({ checkboxArray: [], checkboxListArray: [] });
  };

  /**
   * 주문요청한 아이디를 서버로 보내서 주문한 상품들의 다운로드url을 서버에서 받아서 다운로드하는 함수
   * @param {int} order_id
   */
  downloadImagesSet = async (order_id, order_no) => {
    const res = await apiClient.get(`/generate/download/set/${order_id}`);
    if (res) {
      const products_id = [];
      res.data.data.map(async (item) => {
        if (item.is_convert === true) {
          const downloadingProductId = item.ai_generate.product_id;
          const currentDownloadingArray = this.state.downloadingArray;
          const included = currentDownloadingArray.map((item) => item[0]).includes(downloadingProductId);
          // 전체 다운로드이지만, 개별 다운로드가 진행 중일 때에는 개별 빼고 나머지 다운로드. ex) 0, 1, 2, 3 중에 2번 상품 다운 중일 때 -> 2번 뺴고 0, 1, 3 다운로드
          if (!included) {
            if (isMobile) {
              products_id.push(downloadingProductId);
            } else {
              this.downloadImage(
                `${process.env.REACT_APP_S3_BUCKET_DOMAIN}/${item.ai_generate.res_img_path}`,
                downloadingProductId,
                'jpg',
              );
              this.downloadImage(
                `${process.env.REACT_APP_S3_BUCKET_DOMAIN}/${item.ai_generate.res_psd_path}`,
                downloadingProductId,
                'psd',
              );
            }
          }
        } else {
          const cinveringProductId = item.ai_generate.product_id;
          const currentConvertingArray = this.state.convertingArray;
          // 전체 변환이지만, 개별 변환이 진행 중일 때에는 개별 빼고 나머지 변환 요청. ex) 0, 1, 2, 3 중에 2번 상품 변환 중일 때 -> 2번 뺴고 0, 1, 3 변환
          const included = currentConvertingArray.map((item) => parseInt(item)).includes(cinveringProductId);
          if (!included) {
            const newConvertingArray = [...currentConvertingArray, [cinveringProductId, 0]];
            this.setState({ convertingArray: newConvertingArray });
          }
          this.convertStateChecker();
        }
      });
      // 모바일은 이미지 한꺼번에 서버에서 압축해서 zip으로 받습니다. 모바일 웹은 개별 다운로드가 안되는 버그가 있습니다.
      if (isMobile && products_id.length > 0) {
        this.downloadImageMobile(products_id, order_no);
      }
    }
  };

  /**
   * 영수증을 다운로드하는 함수
   * 주문번호 하위의 상품내역을 가져와서 개수에 따라 영수증 길이를 계산한다
   * id가 receipt인 elelment를 스크린샷을 찍고, 이미지로 만든다.
   * 이미지를 pdf로 변환해서 다운로드한다.
   * 영수증은 따로 서버에 저장하지 않는다. -> 서버에는 주매내역이 있기 때문에 굳이 저장하지 않았다.
   * @param {int} order_id
   */
  downloadReceipt = async (order_id) => {
    const { list } = this.state;
    const productList = list
      .filter((order) => order.order_id === order_id)
      .flatMap((order) => order.order_products.map((product) => product.idx));
    let divImage = '';
    let el = document.querySelector('#receipt');
    await html2canvas(el, {
      height: 1280 + Math.round(productList.length / 20) * 800,
    }).then((canvas) => {
      divImage = canvas.toDataURL('image/png');
      const fileName = `receipt-${Date.now()}.pdf`;
      const pdf = new jsPDF({
        orientation: 'p', // 'p'는 세로 방향, 'l'은 가로 방향
        unit: 'px',
        format: [canvas.width, canvas.height], // 페이지 크기를 이미지와 일치시킵니다.
      });
      pdf.addImage(divImage, 'PNG', canvas.width / 4, 0);
      pdf.save(fileName);
    });
  };

  /**
   * 하나의 상품 아이디를 서버에 보내서 해당상품의 다운로드url을 가져와 다운로드하는 함수
   * @param {int} product_id
   */
  downloadImageOne = async (product_id, product_name) => {
    const res = await apiClient.get(`/generate/download/one/${product_id}`);

    if (res) {
      const is_convert = res.data.data.is_convert;
      if (is_convert === true) {
        const img_url = res.data.data.ai_generate.res_img_path;
        const psd_url = res.data.data.ai_generate.res_psd_path;
        const downloadingProductId = res.data.data.ai_generate.product_id;

        if (isMobile) {
          this.downloadImageMobile([downloadingProductId], res.data.data.order_no);
        } else {
          this.downloadImage(`${process.env.REACT_APP_S3_BUCKET_DOMAIN}/${img_url}`, downloadingProductId, 'jpg');
          this.downloadImage(`${process.env.REACT_APP_S3_BUCKET_DOMAIN}/${psd_url}`, downloadingProductId, 'psd');
        }
        this.convertStateChecker();
      } else {
        const converingProductId = res.data.data.ai_generate.product_id;
        const currentConvertingArray = this.state.convertingArray;
        const newConvertingArray = [...currentConvertingArray, [converingProductId, 0]];
        this.setState({ convertingArray: newConvertingArray });
        this.convertStateChecker();
      }
    }
  };

  getOriginPrice = (orderInfo) => {
    if (!orderInfo?.pay_total_amount) return;
    const targetPriceInfo = {
      originPrice: 0,
      discountValue: 0,
      discountAmount: 0,
      totalPrice: orderInfo?.pay_total_amount ?? 0,
    };

    for (const product of orderInfo.order_products) {
      targetPriceInfo.originPrice += product.product_amount;
    }

    targetPriceInfo.discountAmount = targetPriceInfo.originPrice - targetPriceInfo.totalPrice;
    targetPriceInfo.discountValue = (targetPriceInfo.discountAmount / targetPriceInfo.originPrice) * 100;

    return {
      originPrice: targetPriceInfo.originPrice.toLocaleString(),
      discountValue: targetPriceInfo.discountValue.toLocaleString(),
      discountAmount: targetPriceInfo.discountAmount.toLocaleString(),
      totalPrice: targetPriceInfo.totalPrice.toLocaleString(),
    };
  };

  /**
   * 각 상품의 체크박스를 눌렀을때 반응하는 함수
   * 체크한 상품아이디를 모아놓은 checkboxArray에 체크한 상품아이디가 있으면 제거하고, 없으면 추가한다
   * 이후 updateCommonValue를 실행한다
   * @param {int} order_id
   * @param {int} product_id
   *
   */
  onCheckItem = async (order_id, product_id) => {
    const { checkboxArray, list } = this.state;

    if (checkboxArray.includes(product_id)) {
      await this.setStateAsync({
        checkboxArray: this.state.checkboxArray.filter((item) => item !== product_id),
      });
    } else {
      await this.setStateAsync({
        checkboxArray: [...this.state.checkboxArray, product_id],
      });
    }
    await this.updateCommonValues(order_id);
  };

  /**
   * 해당 order_id에 포함된 상품아이디를 리스트로 가져오고, checkboxArray과 겹치는 아이디의 개수가 리스트의 개수와 같으면
   * 체크한 order_id를 모아놓은 checkboxListArray에 추가하고, 작으면 제거한다
   * @param {int} order_id
   */
  updateCommonValues = async (order_id) => {
    const { checkboxArray, list } = this.state;
    const orderProducts = list
      .filter((order) => order.order_id === order_id)
      .flatMap((order) => order.order_products.map((product) => product.idx));
    const commonValues = orderProducts.filter((value) => checkboxArray.includes(value));

    if (commonValues.length === orderProducts.length) {
      await this.setStateAsync({
        checkboxListArray: [...this.state.checkboxListArray, order_id],
      });
    } else {
      await this.setStateAsync({
        checkboxListArray: this.state.checkboxListArray.filter((item) => item !== order_id),
      });
    }
  };

  /**
   * 각 주문의 체크박스를 체크했을때 반응하는 함수
   * 주문 체크박스를 체크했을 경우, 전체 체크박스리스트에 주문내 상품이 있으면 전체 체크박스리스트에서 해당 상품아이디를 제거
   * 전체 체크박스리스트에 주문내 상품이 없으면 주문내 상품아이디들을 추가
   * @param {int} order_id
   */
  onCheckItemList = async (order_id) => {
    const { checkboxArray, checkboxListArray, list } = this.state;
    const checkList = list
      .filter((order) => order.order_id === order_id)
      .flatMap((order) => order.order_products.map((product) => product.product_id));
    const commonValues = checkList.filter((value) => checkboxArray.includes(value));

    if (commonValues.length > 0) {
      for (const value of commonValues) {
        await this.setStateAsync({ checkboxArray: this.state.checkboxArray.filter((item) => item !== value) });
      }

      if (checkboxListArray.includes(order_id)) {
        await this.setStateAsync({
          checkboxListArray: this.state.checkboxListArray.filter((item) => item !== order_id),
        });
      }
    } else {
      for (const product_id of checkList) {
        if (checkboxArray.includes(product_id)) {
          await this.setStateAsync({ checkboxArray: this.state.checkboxArray.filter((item) => item !== product_id) });
        } else {
          await this.setStateAsync({
            checkboxArray: [...this.state.checkboxArray, product_id],
          });
        }
      }

      if (!checkboxListArray.includes(order_id)) {
        await this.setStateAsync({
          checkboxListArray: [...this.state.checkboxListArray, order_id],
        });
      }
    }
  };

  onCheckAll = async () => {
    const checkboxArray = this.state.checkboxArray;
    const checkboxListArray = this.state.checkboxListArray;
    const list = this.state.list;
    // 주문 목록 체크
    const orderList = list.map((order) => order.order_id);
    // 주문 상품 체크
    const productList = list.flatMap((order) => order.order_products.map((product) => product.product_id));
    const allOrdersIncluded = orderList.every((orderId) => checkboxListArray.includes(orderId));
    const allProductsIncluded = productList.every((productId) => checkboxArray.includes(productId));
    // 체크 리스트 한 페이지 삭제
    if (allOrdersIncluded && allProductsIncluded) {
      productList.forEach((productId) => {
        const index = checkboxArray.indexOf(productId);
        if (index !== -1) {
          checkboxArray.splice(index, 1);
        }
      });
      orderList.forEach((orderId) => {
        const index = checkboxListArray.indexOf(orderId);
        if (index !== -1) {
          checkboxListArray.splice(index, 1);
        }
      });
    } else {
      const newOrderData = orderList.filter((orderId) => !checkboxListArray.includes(orderId));

      const newProductData = productList.filter((productId) => !checkboxArray.includes(productId));
      newProductData.forEach((product_id) => {
        let addToCheckboxArray = true; // 기본적으로 추가 여부를 true로 설정
        // 변환 중인 상품은 체그 하지 않도록
        for (let item of this.state.convertingArray) {
          if (parseInt(item) === product_id) {
            addToCheckboxArray = false; // convertingArray에 존재하면 추가하지 않음
            break;
          }
        }
        // 다운 중인 상품은 체그 하지 않도록
        if (addToCheckboxArray) {
          // convertingArray에 존재하지 않으면 downloadingArray를 확인
          for (let item of this.state.downloadingArray) {
            if (parseInt(item[0]) === product_id) {
              addToCheckboxArray = false; // downloadingArray에 존재하면 추가하지 않음
              break;
            }
          }
        }

        if (addToCheckboxArray) {
          checkboxArray.push(product_id); // 추가 여부가 true이면 checkboxArray에 추가
        }
      });
      newOrderData.forEach((orderId) => {
        // 해당 주문에 구입한 상품 id만 들고오기
        const checkList = list
          .filter((order) => order.order_id === orderId)
          .flatMap((order) => order.order_products.map((product) => product.product_id));
        // 해당 주문에 모든 상품이 클릭 되어 있는지 확인
        const allProductsIncluded = checkList.every((productId) => checkboxArray.includes(productId));
        if (allProductsIncluded) {
          checkboxListArray.push(orderId);
        }
      });
    }
    await this.setStateAsync({ checkboxArray: checkboxArray, checkboxListArray: checkboxListArray });
  };

  /**
   * 환불이 가능한지 체크하는 함수
   * 체크한 리스트의 아이템 중 is_download가 true이거 order_datetime과 현재시간과의 차이가 7일이상 나면 경고창을 띄운다
   * @param {int} id
   * @param {int} order_id
   */
  onCheckRefund = async (id, order_id) => {
    const { refundOrder, checkboxArray, list, refundArray } = this.state;

    // 현재 시간을 얻기
    const current_time = new Date();

    // 7일 전의 시간을 계산
    const sevenDaysAgo = new Date(current_time);
    sevenDaysAgo.setDate(current_time.getDate() - 7);
    const notRefundList = list
      .map((item) => item.order_products)
      .flat()
      .reduce((acc, item) => {
        if (item.is_download) {
          acc.push(item.product_id);
        }
        const orderDatetime = new Date(item.order_datetime);
        if (orderDatetime <= sevenDaysAgo) {
          acc.push(item.product_id);
        }
        return acc;
      }, []);

    const isRefund = notRefundList.filter((item) => checkboxArray.includes(item));
    if (isRefund.length > 0) {
      return alert(CONFIG_MESSAGE.CONFIRM_PURCHASE_ITEM_EXIST_MSG);
    }

    await this.setStateAsync({ refundArray: [...checkboxArray] });

    this.onShowRefundModal();
  };

  reqRefund = async () => {
    const { reasontype, reasontxt, refundArray } = this.state;

    //refundArray 에 환불할 상품의 product_id 들의 배열을 넘겨줌.
    if (refundArray.length === 0) {
      return alert(CONFIG_MESSAGE.SELECT_REFUND_ITEM_MSG);
    } else if (reasontype === '') {
      return alert(CONFIG_MESSAGE.REQUEST_SELECT_REFUND_TYPE_MSG);
    } else if (reasontxt === '') {
      return alert(CONFIG_MESSAGE.REQUEST_ENTER_REFUND_REASON_MSG);
    }

    const res = await apiClient.post('/generate/refund/request', {
      type: reasontype,
      reason: reasontxt,
      products: refundArray,
    });

    if (res) {
      alert(getStringByLang(res.data.message_ko, res.data.message_en, res.data.message_jp));
      this.setState({
        reasontype: '',
        reasontxt: '',
        refundOrder: '',
        refundArray: [],
        checkboxArray: [],
        checkboxListArray: [],
      });
      this.getList(1);
      this.onCloseRefundModal();
    }
  };

  showProductList = (index) => {
    const { checkbox_ref, invoice_detail_ref, invoice_ref, order_amount_ref, design_file_ref } = this;
    const checkboxRefWidth = checkbox_ref?.getBoundingClientRect().width;
    const invoiceDetailWidth = invoice_detail_ref?.getBoundingClientRect().width;
    const invoiceWidth = invoice_ref?.getBoundingClientRect().width;
    const orderAmountRefWidth = order_amount_ref?.getBoundingClientRect().width;
    const designFileWidth = design_file_ref?.getBoundingClientRect().width;
    const size = checkboxRefWidth + invoiceDetailWidth + invoiceWidth;

    this.setState((state) => ({
      list: state.list.map((item2, k) => {
        if (k === index) {
          return {
            ...item2,
            ditemopen: !item2.ditemopen,
          };
        }
        return item2;
      }),
      childWidthSize: size,
      checkboxRefWidth: checkboxRefWidth,
      invoiceDetailWidth: invoiceDetailWidth,
      invoiceWidth: invoiceWidth,
      orderAmountRefWidth: orderAmountRefWidth,
      designFileWidth: designFileWidth,
    }));
  };

  render() {
    const { t } = this.props;
    const {
      tabindex,
      monthtype,
      startDate,
      endDate,
      ditemopen,
      receiptmodal,
      refundmodal,
      reasontype,
      reasontxt,
      list,
      page,
      total_pages,
      receiptTarget,
      refundArray,
      checkboxArray,
      checkboxListArray,
      amount_products,
    } = this.state;
    // 주문 목록 체크
    const orderList = list.map((order) => order.order_id);
    // 주문 상품 체크
    const productList = list.flatMap((order) => order.order_products.map((product) => product.product_id));
    // 전 주문 번호 선택 됬는지 확인
    const allOrdersIncluded = orderList.every((orderId) => checkboxListArray.includes(orderId));
    // 전 상품 번호 선택 됬는지 확인
    const allProductsIncluded = productList.every((productId) => checkboxArray.includes(productId));
    let isChecked;
    if (allProductsIncluded && allOrdersIncluded) {
      isChecked = true;
    } else {
      isChecked = false;
    }
    const lang = getCurrentLang();

    return (
      <div style={{ flex: 1, width: '100%' }}>
        {/*PC, 태블릿========================================================웹화면==================================================================================== */}
        <MediaQuery min={600}>
          <div style={{ marginLeft: '35px' }}>
            <TitleBlock title={t('transactions_buy')} />
            <HSLine bgcolor="#dddddd" height={1} />
            <VerticalSp sp={'2vw'} style={{ maxHeight: 37, minHeight: 16 }} />
            <div style={{ display: 'flex', paddingLeft: '3vw' }}>
              <div style={{ display: 'flex', justifyContent: 'center', flex: 1, alignItems: 'center' }}>
                <img alt={''} src={images.icon_warning} style={{ width: 80, height: 80 }} />
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  paddingLeft: 30,
                  fontFamily: 'NSCJKrR',
                  fontSize: 16,
                  whiteSpace: 'nowarp',
                  flex: 5,
                }}
              >
                {translationData.purchaseWarning[lang]}
              </div>
            </div>
            <VerticalSp sp={'2vw'} style={{ maxHeight: 37, minHeight: 16 }} />
            <div style={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}>
              <div style={{ width: 150, display: 'flex', justifyContent: 'center' }}>
                <PurTabButton
                  active={tabindex === 0}
                  onClick={async () => {
                    await this.setStateAsync({ tabindex: 0 });
                    this.getList(1);
                  }}
                  title={t('purchases')}
                />
              </div>
              <div style={{ width: 150, display: 'flex', justifyContent: 'center' }}>
                <PurTabButton
                  active={tabindex === 1}
                  onClick={async () => {
                    await this.setStateAsync({ tabindex: 1 });
                    this.getList(1);
                  }}
                  title={t('refund_list')}
                />
              </div>
            </div>
            <VerticalSp sp={'2.2vw'} style={{ maxHeight: 40, minHeight: 20 }} />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: isMobile ? 'center' : 'flex-start' }}>
              <PurOptionButton
                active={monthtype === 3}
                onClick={async () => {
                  await this.setStateAsync({
                    monthtype: 3,
                    startDate: moment().subtract(3, 'month').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD'),
                  });
                  this.getList(1);
                }}
                title={`3${t('months')}`}
              />
              <PurOptionButton
                active={monthtype === 6}
                onClick={async () => {
                  await this.setStateAsync({
                    monthtype: 6,
                    startDate: moment().subtract(6, 'month').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD'),
                  });
                  this.getList(1);
                }}
                title={`6${t('months')}`}
              />
              <PurOptionButton
                active={monthtype === 12}
                onClick={async () => {
                  await this.setStateAsync({
                    monthtype: 12,
                    startDate: moment().subtract(12, 'month').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD'),
                  });
                  this.getList(1);
                }}
                title={`12${t('months')}`}
              />
              <HorizontalSp sp={'2.2vw'} style={{ maxWidth: 40, minWidth: 20 }} />
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={koLocale}>
                <DatePicker
                  DialogProps={{ style: { zIndex: 9999 } }}
                  value={startDate}
                  labelFunc={this.labelStartCalendar}
                  onChange={this.handleStartDateChange}
                  TextFieldComponent={TextFieldComp}
                />
                <span
                  style={{
                    fontFamily: 'NSCJKrR',
                    fontSize: 24,
                    color: '#999999',
                    width: '2.2vw',
                    maxWidth: 40,
                    minWidth: 20,
                    textAlign: 'center',
                  }}
                >
                  ~
                </span>
                <DatePicker
                  DialogProps={{ style: { zIndex: 9999 } }}
                  value={endDate}
                  labelFunc={this.labelEndCalendar}
                  onChange={this.handleEndDateChange}
                  TextFieldComponent={TextFieldComp}
                />
              </MuiPickersUtilsProvider>
              <HorizontalSp sp={'2.2vw'} style={{ maxWidth: 40, minWidth: 20 }} />

              <BorderBtn
                onClick={() => this.getList(1)}
                style={{ backgroundColor: '#ff8a06', color: 'white', width: '8%' }}
              >
                <img
                  alt=""
                  src={images.topbar_search}
                  style={{
                    width: 12,
                    marginRight: 5,
                    filter: 'brightness(0) invert(1) saturate(100%) hue-rotate(180deg)',
                  }}
                />
                {t('search_2')}
              </BorderBtn>
            </div>
            <VerticalSp sp={'1.2vw'} style={{ maxHeight: 40, minHeight: 20 }} />
            {/* ====================================================웹화면 -> 결제내역===============================================*/}

            {tabindex === 0 ? (
              <>
                <section style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                  <CheckBox onClick={() => this.onCheckAll()} style={{ margin: 15 }} key={'all'}>
                    <CheckMark checked={isChecked} />
                  </CheckBox>
                  {checkboxArray.length === 0 ? (
                    <>
                      {/* 체크박스에 아무것도 체크하지 않았을 때, 두개 버튼이 모두 비활성화 되어있음. */}
                      {/* <BorderBtn style={{cursor:"default" }}>
                        <img alt="" src={images.guide_download} style={{ width: 13, marginRight: 4}} />
                        {t('download_selected')}
                      </BorderBtn> */}
                      <HorizontalSp sp={10} />
                      <BorderBtn style={{ cursor: 'default' }}>{t('refund')}</BorderBtn>
                    </>
                  ) : (
                    <>
                      {/* 체크박스에 한개라도 체크가 된 경우, 두개 체크 버튼 활성화 */}
                      {/* <BorderBtn style={{backgroundColor: '#fe8b07',color: 'white',}} onClick={this.throttledDownload}>
                        <img alt="" src={images.guide_download} style={{ width: 13, marginRight: 4, filter: 'brightness(0) invert(1) saturate(100%) hue-rotate(180deg)'}} />
                      {t('download_selected')}
                      </BorderBtn> */}
                      <HorizontalSp sp={10} />
                      <BorderBtn style={{ backgroundColor: 'black', color: 'white' }} onClick={this.onCheckRefund}>
                        {t('refund')}
                      </BorderBtn>
                    </>
                  )}
                </section>

                <VerticalSp sp={'1.2vw'} style={{ maxHeight: 40, minHeight: 20 }} />
                <TableContainer>
                  <Table>
                    <CustomHead>
                      <TableRow>
                        <TableCell ref={(checkbox_ref) => (this.checkbox_ref = checkbox_ref)}>
                          <HeadCell style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>{''}</HeadCell>
                        </TableCell>
                        <TableCell
                          align="flex-start"
                          ref={(invoice_detail_ref) => (this.invoice_detail_ref = invoice_detail_ref)}
                        >
                          <HeadCell>{t('invoice_detail')}</HeadCell>
                        </TableCell>
                        <TableCell
                          style={{ padding: 0, width: 80, minWidth: 80 }}
                          align="center"
                          ref={(invoice_ref) => (this.invoice_ref = invoice_ref)}
                        >
                          <HeadCell>{t('invoice')}</HeadCell>
                        </TableCell>
                        <TableCell
                          style={{ padding: 0, minWidth: 100 }}
                          align="center"
                          ref={(order_amount_ref) => (this.order_amount_ref = order_amount_ref)}
                        >
                          <HeadCell>{t('order_amount')}</HeadCell>
                        </TableCell>
                        <TableCell
                          style={{ padding: 0, minWidth: 100 }}
                          align="center"
                          ref={(design_file_ref) => (this.design_file_ref = design_file_ref)}
                        >
                          <HeadCell>{t('design_file')}</HeadCell>
                        </TableCell>
                      </TableRow>
                    </CustomHead>

                    <CustomBody>
                      {list.map((item, index) => (
                        <>
                          <TableRow key={`list-${index}`}>
                            <CustomCell>
                              <CheckBox
                                onClick={() => this.onCheckItemList(item.order_id)}
                                style={{ marginRight: 15, marginBottom: 8 }}
                                key={item.order_id}
                              >
                                <CheckMark checked={checkboxListArray.includes(item.order_id)} />
                              </CheckBox>
                            </CustomCell>
                            <CustomCell style={{ padding: 0 }} align="left">
                              {item.order_products.length > 0 && (
                                <BodyCell
                                  style={{
                                    fontFamily: 'NSCJKrB',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    this.showProductList(index);
                                  }}
                                >
                                  <div>
                                    <span>{`${item.order_no?.substring(0, 8)}`}</span>
                                    <span style={{ color: '#999999' }}>&nbsp;{`(+${item.order_products.length})`}</span>
                                  </div>
                                  <div>
                                    <span
                                      style={{ fontFamily: 'NSCJKrR', fontSize: 13, color: '#999999' }}
                                    >{`${item.order_datetime.substring(0, 16).replace(/-/gi, '.')}`}</span>
                                    <img
                                      alt=""
                                      src={ditemopen ? images.icon_collapse : images.icon_expend}
                                      style={{ marginLeft: 8 }}
                                    />
                                  </div>
                                </BodyCell>
                              )}
                            </CustomCell>
                            <CustomCell style={{ padding: 0, width: 80 }} align="center">
                              {
                                <ReceiptBtn
                                  onClick={() => {
                                    this.setState({ receiptmodal: true, receiptTarget: index });
                                  }}
                                >
                                  {t('view_invoice')}
                                </ReceiptBtn>
                              }
                            </CustomCell>
                            <CustomCell style={{ padding: 0 }} align="center">
                              {item.pay_method === 'credit' ? (
                                <BodyCell style={{ fontFamily: 'NSCJKrB', justifyContent: 'center' }}>
                                  {item.use_credit}
                                  {t('credit')}
                                </BodyCell>
                              ) : (
                                <BodyCell style={{ fontFamily: 'NSCJKrB', justifyContent: 'center' }}>
                                  {item.pay_currency === 'KRW'
                                    ? '₩'
                                    : item.pay_currency === 'USD'
                                    ? '$'
                                    : item.pay_currency === 'EUR'
                                    ? '€'
                                    : ''}
                                  {item.pay_total_amount.toLocaleString()}
                                </BodyCell>
                              )}
                            </CustomCell>
                            <CustomCell>
                              <center>
                                <ConvertBtn
                                  t={t}
                                  item={item}
                                  onClick={() => {
                                    this.downloadImagesSet(item.order_id, item.order_no);
                                  }}
                                  convertingArray={this.state.convertingArray}
                                  downloadingArray={this.state.downloadingArray}
                                  is_VirtualAccount_purchuage={
                                    item.pay_detail_method === '가상계좌' && item.pay_status !== 1
                                  }
                                />
                              </center>
                            </CustomCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ padding: 0, border: 0 }} colSpan={5}>
                              <Collapse in={item.ditemopen} timeout="auto" unmountOnExit>
                                {item.order_products.map((order, j) => (
                                  <DetailItem
                                    key={j}
                                    style={{
                                      paddingLeft:
                                        tabindex === 0 &&
                                        (order.is_download || moment(order.order_datetime).add(7, 'days') < moment())
                                          ? ''
                                          : '',
                                      display: tabindex === 0 && order.refund_status !== 0 && 'none',
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: this.state.childWidthSize - 10,
                                      }}
                                    >
                                      {tabindex === 0 && (
                                        <CheckBox
                                          onClick={() => this.onCheckItem(item.order_id, order.product_id)}
                                          style={{ marginRight: 15, marginBottom: 8 }}
                                          key={j}
                                        >
                                          <CheckBoxChecker
                                            checked={checkboxArray.includes(order.product_id)}
                                            product_id={order.product_id}
                                            convertingArray={this.state.convertingArray}
                                            downloadingArray={this.state.downloadingArray}
                                          />
                                        </CheckBox>
                                      )}

                                      <Link to={`/generate/result/detail/${order.product_id}`}>
                                        <Ratio
                                          ratio={1}
                                          style={{
                                            width: 100,
                                            backgroundColor: '#cccccc',
                                            backgroundImage: `url(${order.ai_generate.res_thumb_path})`,
                                            backgroundSize: 'cover',
                                            marginLeft: '30px',
                                          }}
                                        />
                                      </Link>
                                      <HorizontalSp sp={'1.1vw'} style={{ minWidth: 10, maxWidth: 20 }} />
                                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <DItemTitle>
                                          <Link
                                            to={`/generate/result/detail/${order.product_id}`}
                                            style={{ textDecoration: 'none', color: 'black' }}
                                          >
                                            {order.ai_generate.img_name}
                                          </Link>
                                        </DItemTitle>
                                        <DItemText style={{ color: '#686868' }}>
                                          {`Classic (${t('exclusive')})`}
                                        </DItemText>
                                        {item.pay_detail_method === '가상계좌' && item.pay_status !== 1 ? (
                                          <>
                                            {item.payment_info &&
                                              (() => {
                                                const paymentInfo = JSON.parse(item.payment_info);
                                                const virtualAccount = paymentInfo.virtualAccount || {};
                                                return (
                                                  <>
                                                    <DItemDowndTxt
                                                      style={{ fontSize: '13px', color: '#686868', textAlign: 'left' }}
                                                    >
                                                      상태: {t('deposit_pending')}
                                                    </DItemDowndTxt>
                                                    <DItemDowndTxt
                                                      style={{ fontSize: '13px', color: '#686868', textAlign: 'left' }}
                                                    >
                                                      {banks[virtualAccount.bankCode]}:{' '}
                                                      {virtualAccount.accountNumber || 'N/A'}
                                                    </DItemDowndTxt>
                                                    <DItemDowndTxt
                                                      style={{ fontSize: '13px', color: '#686868', textAlign: 'left' }}
                                                    >
                                                      입금 기한일:{' '}
                                                      {virtualAccount.dueDate
                                                        ? virtualAccount.dueDate.substring(0, 16).replace(/-/g, '.')
                                                        : 'N/A'}
                                                    </DItemDowndTxt>
                                                  </>
                                                );
                                              })()}
                                          </>
                                        ) : (order.is_download && order.product_download_datetime) ||
                                          moment(order.order_datetime).add(7, 'days') < moment() ? (
                                          <DItemDowndTxt
                                            style={{ fontSize: '13px', color: 'green', textAlign: 'left' }}
                                          >
                                            상태: {t('order_approved')}
                                          </DItemDowndTxt>
                                        ) : (
                                          <DItemDowndTxt
                                            style={{ fontSize: '13px', color: '#686868', textAlign: 'left' }}
                                          >
                                            상태: {t('order_pending')}
                                          </DItemDowndTxt>
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display: 'flex',
                                        width: this.state.orderAmountRefWidth,
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <DItemCost style={{ padding: 0 }}>
                                        {item.pay_method === 'credit' ? (
                                          <>1 {t('credit')} </>
                                        ) : (
                                          <>
                                            {item.pay_currency === 'KRW'
                                              ? '₩'
                                              : item.pay_currency === 'USD'
                                              ? '$'
                                              : item.pay_currency === 'EUR'
                                              ? '€'
                                              : ''}
                                            {order.product_amount.toLocaleString()}
                                          </>
                                        )}
                                      </DItemCost>
                                    </div>

                                    {tabindex === 0 && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          width: this.state.designFileWidth - 20,
                                          paddingLeft: 10,
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <ConvertBtnEach
                                          t={t}
                                          item={order}
                                          onClick={() => this.downloadImageOne(order.product_id, order.product_name)}
                                          convertingArray={this.state.convertingArray}
                                          downloadingArray={this.state.downloadingArray}
                                          list={this.state.list}
                                          index={index}
                                          productIndex={j}
                                          setList={this.setList}
                                          is_VirtualAccount_purchuage={
                                            item.pay_detail_method === '가상계좌' && item.pay_status !== 1
                                          }
                                        />
                                      </div>
                                    )}
                                  </DetailItem>
                                ))}
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        </>
                      ))}
                      {list.length === 0 && (
                        <TableRow>
                          <TableCell align="center" colSpan={6}>
                            <GoodCell style={{ fontFamily: 'NSCJKrB', width: isMobile ? 'max-content' : 'auto' }}>
                              {t('no_data')}
                            </GoodCell>
                          </TableCell>
                        </TableRow>
                      )}
                    </CustomBody>
                  </Table>
                  <VerticalSp sp={'2.2vw'} style={{ maxHeight: 40, minHeight: 20 }} />
                </TableContainer>
              </>
            ) : (
              <>
                {/* ==========================================================웹화면 -> 환불내역 ======================================================================== */}
                <VerticalSp sp={'1.2vw'} style={{ maxHeight: 40, minHeight: 20 }} />
                <TableContainer>
                  <Table>
                    <CustomHead>
                      <TableRow>
                        <TableCell ref={(checkbox_ref) => (this.checkbox_ref = checkbox_ref)}>
                          <HeadCell style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>{''}</HeadCell>
                        </TableCell>
                        <TableCell
                          align="flex-start"
                          ref={(invoice_detail_ref) => (this.invoice_detail_ref = invoice_detail_ref)}
                        >
                          <HeadCell>{t('invoice_detail')}</HeadCell>
                        </TableCell>
                        <TableCell
                          style={{ padding: 0, width: 80, minWidth: 80 }}
                          align="center"
                          ref={(invoice_ref) => (this.invoice_ref = invoice_ref)}
                        >
                          <HeadCell>{t('invoice')}</HeadCell>
                        </TableCell>
                        <TableCell
                          style={{ padding: 0, minWidth: 100 }}
                          align="center"
                          ref={(order_amount_ref) => (this.order_amount_ref = order_amount_ref)}
                        >
                          <HeadCell>{t('order_amount')}</HeadCell>
                        </TableCell>
                        <TableCell
                          style={{ padding: 0, minWidth: 100 }}
                          align="center"
                          ref={(design_file_ref) => (this.design_file_ref = design_file_ref)}
                        >
                          <HeadCell>{t('refund_status')}</HeadCell>
                        </TableCell>
                      </TableRow>
                    </CustomHead>
                    <CustomBody>
                      {list.map((item, index) => (
                        <>
                          <TableRow key={`list-${index}`}>
                            <CustomCell>{''}</CustomCell>
                            <CustomCell style={{ padding: 0 }} align="left">
                              {item.order_products.length > 0 && (
                                <BodyCell
                                  style={{
                                    fontFamily: 'NSCJKrB',
                                    minWidth: 150,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    this.showProductList(index);
                                  }}
                                >
                                  <div>
                                    <span>{`${item.order_no?.substring(0, 8)}`}</span>
                                    <span style={{ color: '#999999' }}>&nbsp;{`(+${item.order_products.length})`}</span>
                                  </div>
                                  <div>
                                    <span
                                      style={{ fontFamily: 'NSCJKrR', fontSize: 13, color: '#999999' }}
                                    >{`${item.order_datetime.substring(0, 16).replace(/-/gi, '.')}`}</span>
                                    <img
                                      alt=""
                                      src={ditemopen ? images.icon_collapse : images.icon_expend}
                                      style={{ marginLeft: 8 }}
                                    />
                                  </div>
                                </BodyCell>
                              )}
                            </CustomCell>
                            <CustomCell style={{ padding: 0, width: 80 }} align="center">
                              <ReceiptBtn
                                onClick={() => {
                                  this.setState({ receiptmodal: true, receiptTarget: index });
                                }}
                              >
                                {t('view_invoice')}
                              </ReceiptBtn>
                            </CustomCell>
                            <CustomCell style={{ padding: 0 }} align="center">
                              {item.pay_method === 'credit' ? (
                                <BodyCell style={{ fontFamily: 'NSCJKrB', justifyContent: 'center' }}>
                                  1{t('credit')}
                                </BodyCell>
                              ) : (
                                <BodyCell style={{ fontFamily: 'NSCJKrB', justifyContent: 'center' }}>
                                  {item.pay_currency === 'KRW'
                                    ? '₩'
                                    : item.pay_currency === 'USD'
                                    ? '$'
                                    : item.pay_currency === 'EUR'
                                    ? '€'
                                    : ''}
                                  {item.pay_total_amount.toLocaleString()}
                                </BodyCell>
                              )}
                            </CustomCell>
                            <CustomCell>
                              <center>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <span style={{ color: '#36792B' }}>
                                    {t('under_refund')}:{' '}
                                    {item.order_products.filter((product) => product.refund_status === 1).length}
                                  </span>
                                  <VerticalSp sp={5} />
                                  <span style={{ color: '#FF8A06' }}>
                                    {t('refund_is_completed')}:{' '}
                                    {item.order_products.filter((product) => product.refund_status === 3).length}
                                  </span>
                                </div>
                              </center>
                            </CustomCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ padding: 0, border: 0 }} colSpan={5}>
                              <Collapse in={item.ditemopen} timeout="auto" unmountOnExit>
                                {item.order_products.map((order, j) => (
                                  <DetailItem key={j} style={{ paddingLeft: 50 }}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: this.state.childWidthSize + this.state.amount_products - 60,
                                      }}
                                    >
                                      <Ratio
                                        ratio={1}
                                        style={{
                                          width: 80,
                                          backgroundColor: '#cccccc',
                                          backgroundImage: `url(${order.ai_generate.res_thumb_path})`,
                                          backgroundSize: 'cover',
                                        }}
                                      />
                                      <HorizontalSp sp={'1.1vw'} style={{ minWidth: 10, maxWidth: 20 }} />
                                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <DItemTitle>{order.ai_generate.img_name}</DItemTitle>
                                        <DItemText style={{ color: '#686868' }}>
                                          {`Classic (${t('exclusive')})`}
                                        </DItemText>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display: 'flex',
                                        width: this.state.orderAmountRefWidth,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <DItemCost style={{ padding: 0 }}>
                                        {item.pay_method === 'credit' ? (
                                          <>1 {t('credit')} </>
                                        ) : (
                                          <>
                                            {item.pay_currency === 'KRW'
                                              ? '₩'
                                              : item.pay_currency === 'USD'
                                              ? '$'
                                              : item.pay_currency === 'EUR'
                                              ? '€'
                                              : ''}
                                            {item.pay_total_amount.toLocaleString()}
                                          </>
                                        )}
                                      </DItemCost>
                                    </div>
                                    <DItemText
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontFamily: 'NSCJKrR',
                                        justifyContent: 'center',
                                        fontSize: 14,
                                        whiteSpace: 'nowrap',
                                        color: order.refund_status === 1 ? '#36792B' : '#FF8A06',
                                        width: this.state.designFileWidth - 10,
                                      }}
                                    >
                                      {order.refund_status === 1
                                        ? t('under_refund')
                                        : order.refund_status === 3
                                        ? t('refund_is_completed')
                                        : ''}
                                    </DItemText>
                                  </DetailItem>
                                ))}
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        </>
                      ))}
                      {list.length === 0 && (
                        <TableRow>
                          <TableCell align="center" colSpan={6}>
                            <GoodCell style={{ fontFamily: 'NSCJKrB', width: isMobile ? 'max-content' : 'auto' }}>
                              {t('no_data')}
                            </GoodCell>
                          </TableCell>
                        </TableRow>
                      )}
                    </CustomBody>
                  </Table>
                  <VerticalSp sp={'2.2vw'} style={{ maxHeight: 40, minHeight: 20 }} />
                </TableContainer>
              </>
            )}
          </div>
        </MediaQuery>

        {/* ==============================================================================================================================모바일화면==============================================================================================================================*/}
        <MediaQuery max={599}>
          <TitleBlock title={t('transactions_buy')} />
          <HSLine bgcolor="#dddddd" height={1} />
          <VerticalSp sp={'2vw'} style={{ maxHeight: 37, minHeight: 16 }} />
          <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '3vw' }}>
            <div style={{ display: 'flex', justifyContent: 'center', flex: 1, height: 'fit-content' }}>
              <img alt={''} src={images.icon_warning} />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center',
                fontFamily: 'NSCJKrR',
                fontSize: 16,
                whiteSpace: 'nowarp',
                flex: 5,
              }}
            >
              {translationData.purchaseWarningMobile[lang]}
            </div>
          </div>
          <VerticalSp sp={'2vw'} style={{ maxHeight: 37, minHeight: 16 }} />
          <div style={{ display: 'flex', justifyContent: isMobile ? 'center' : 'center' }}>
            <div style={{ width: 150, display: 'flex', justifyContent: 'center' }}>
              <PurTabButton
                active={tabindex === 0}
                onClick={async () => {
                  await this.setStateAsync({ tabindex: 0 });
                  this.getList(1);
                }}
                title={t('purchases')}
                style={{ fontSize: 20 }}
              />
            </div>
            <div style={{ width: 150, display: 'flex', justifyContent: 'center' }}>
              <PurTabButton
                active={tabindex === 1}
                onClick={async () => {
                  await this.setStateAsync({ tabindex: 1 });
                  this.getList(1);
                }}
                title={t('refund_list')}
                style={{ fontSize: 20 }}
              />
            </div>
          </div>
          <VerticalSp sp={'2.2vw'} style={{ maxHeight: 40, minHeight: 20 }} />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <PurOptionButton
              style={{ width: 150 }}
              active={monthtype === 3}
              onClick={async () => {
                await this.setStateAsync({
                  monthtype: 3,
                  startDate: moment().subtract(3, 'month').format('YYYY-MM-DD'),
                  endDate: moment().format('YYYY-MM-DD'),
                });
                this.getList(1);
              }}
              title={`3${t('months')}`}
            />
            <PurOptionButton
              style={{ width: 150 }}
              active={monthtype === 6}
              onClick={async () => {
                await this.setStateAsync({
                  monthtype: 6,
                  startDate: moment().subtract(6, 'month').format('YYYY-MM-DD'),
                  endDate: moment().format('YYYY-MM-DD'),
                });
                this.getList(1);
              }}
              title={`6${t('months')}`}
            />
            <PurOptionButton
              style={{ width: 150 }}
              active={monthtype === 12}
              onClick={async () => {
                await this.setStateAsync({
                  monthtype: 12,
                  startDate: moment().subtract(12, 'month').format('YYYY-MM-DD'),
                  endDate: moment().format('YYYY-MM-DD'),
                });
                this.getList(1);
              }}
              title={`12${t('months')}`}
            />
          </div>
          <VerticalSp sp={25} />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={koLocale}>
              <DatePicker
                DialogProps={{ style: { zIndex: 9999 } }}
                value={startDate}
                labelFunc={this.labelStartCalendar}
                onChange={this.handleStartDateChange}
                TextFieldComponent={TextFieldComp}
              />
              <span
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 24,
                  color: '#999999',
                  width: '2.2vw',
                  maxWidth: 40,
                  minWidth: 20,
                  textAlign: 'center',
                  marginLeft: 5,
                  marginRight: 5,
                }}
              >
                ~
              </span>
              <DatePicker
                DialogProps={{ style: { zIndex: 9999 } }}
                value={endDate}
                labelFunc={this.labelEndCalendar}
                onChange={this.handleEndDateChange}
                TextFieldComponent={TextFieldComp}
                style={{ minWidth: 100 }}
              />
            </MuiPickersUtilsProvider>
            <HorizontalSp sp={35} style={{ maxWidth: 40, minWidth: 10 }} />
            <NorButton
              style={{ fontFamily: 'NSCJKrB', fontSize: 14, width: 80, height: 40, borderRadius: 5, minWidth: 40 }}
              onClick={() => this.getList(1)}
            >
              {t('search_2')}
            </NorButton>
          </div>
          <VerticalSp sp={'1.2vw'} style={{ maxHeight: 40, minHeight: 8 }} />
          {/* ============================================================모바일화면 -> 결제내역 ==================================================================*/}
          {tabindex === 0 ? (
            <>
              <section style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                <CheckBox onClick={() => this.onCheckAll()} style={{ margin: 15 }} key={'all'}>
                  <CheckMark checked={isChecked} />
                </CheckBox>
                {checkboxArray.length === 0 ? (
                  <>
                    {/* 모바일은 여러 상품 다운받기가 너무 느려서 일시 중단했습니다. */}
                    {/* <BorderBtn style={{cursor:"default" }}>
                        <img alt="" src={images.guide_download} style={{ width: 13, marginRight: 4}} />
                        {t('download_selected')}
                      </BorderBtn> */}
                    {/* <HorizontalSp sp={10} /> */}
                    <BorderBtn style={{ cursor: 'default' }}>{t('refund')}</BorderBtn>
                  </>
                ) : (
                  <>
                    {/* <BorderBtn style={{backgroundColor: '#fe8b07',color: 'white',}} onClick={this.downloadSelectedImage}>
                        <img alt="" src={images.guide_download} style={{ width: 13, marginRight: 4, filter: 'brightness(0) invert(1) saturate(100%) hue-rotate(180deg)'}} />
                      {t('download_selected')}
                      </BorderBtn>
                      <HorizontalSp sp={10} /> */}
                    <BorderBtn style={{ backgroundColor: 'black', color: 'white' }} onClick={this.onCheckRefund}>
                      {t('refund')}
                    </BorderBtn>
                  </>
                )}
              </section>
              <VerticalSp sp={'1.2vw'} style={{ maxHeight: 40, minHeight: 8 }} />
              <TableContainer>
                <Table style={{ maxWidth: '100%' }}>
                  <CustomHead>
                    <TableRow>
                      <TableCell>
                        <HeadCell
                          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                          ref={(checkbox_ref) => (this.checkbox_ref = checkbox_ref)}
                        >
                          {''}
                        </HeadCell>
                      </TableCell>
                      <TableCell
                        style={{ padding: 0, minWidth: 100 }}
                        align="flex-start"
                        ref={(invoice_detail_ref) => (this.invoice_detail_ref = invoice_detail_ref)}
                      >
                        <HeadCell>{t('invoice_detail')}</HeadCell>
                      </TableCell>
                      <TableCell
                        style={{ padding: 10, maxWidth: 100 }}
                        align="center"
                        ref={(order_amount_ref) => (this.order_amount_ref = order_amount_ref)}
                      >
                        <HeadCell>{t('order_amount')}</HeadCell>
                      </TableCell>
                      <TableCell
                        style={{ padding: 0, maxWidth: 100 }}
                        align="center"
                        ref={(design_file_ref) => (this.design_file_ref = design_file_ref)}
                      >
                        <HeadCell>{t('design_file')}</HeadCell>
                      </TableCell>
                    </TableRow>
                  </CustomHead>
                  <CustomBody>
                    {list.map((item, index) => (
                      <>
                        <TableRow key={`list-${index}`}>
                          <CustomCell style={{ width: 18 }}>
                            <CheckBox
                              onClick={() => this.onCheckItemList(item.order_id)}
                              style={{ marginBottom: 8, width: 18 }}
                              key={item.order_id}
                            >
                              <CheckMark checked={checkboxListArray.includes(item.order_id)} />
                            </CheckBox>
                          </CustomCell>
                          <CustomCell style={{ padding: 0 }} align="left">
                            {item.order_products.length > 0 && (
                              <BodyCell
                                style={{
                                  fontFamily: 'NSCJKrB',
                                  fontSize: 12,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'flex-start',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  this.showProductList(index);
                                }}
                              >
                                <div>
                                  <span>{`${item.order_no?.substring(0, 8)}`}</span>
                                  <span style={{ color: '#999999' }}>&nbsp;{`(+${item.order_products.length})`}</span>
                                </div>
                                <div style={{}}>
                                  <span
                                    style={{ fontFamily: 'NSCJKrR', fontSize: 10, color: '#999999' }}
                                  >{`${item.order_datetime.substring(0, 16).replace(/-/gi, '.')}`}</span>
                                  <img
                                    alt=""
                                    src={ditemopen ? images.icon_collapse : images.icon_expend}
                                    style={{ marginLeft: 2 }}
                                    width={10}
                                  />
                                </div>
                              </BodyCell>
                            )}
                          </CustomCell>
                          <CustomCell style={{ padding: 0, justifyContent: 'center' }} align="center">
                            <DItemCostMobile style={{}}>
                              {item.pay_method === 'credit' ? (
                                <>1 {t('credit')} </>
                              ) : (
                                <>
                                  {item.pay_currency === 'KRW'
                                    ? '₩'
                                    : item.pay_currency === 'USD'
                                    ? '$'
                                    : item.pay_currency === 'EUR'
                                    ? '€'
                                    : ''}
                                  {item.pay_total_amount.toLocaleString()}
                                </>
                              )}
                            </DItemCostMobile>
                            {tabindex === 0 ? (
                              <center>
                                <ReceiptBtnMobile
                                  onClick={() => {
                                    this.setState({ receiptmodal: true, receiptTarget: index });
                                  }}
                                >
                                  {t('view_invoice')}
                                </ReceiptBtnMobile>
                              </center>
                            ) : (
                              <div style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: '#999999' }}>
                                {item.refund_status === 1
                                  ? t('under_refund')
                                  : item.refund_status === 3
                                  ? t('refund_is_completed')
                                  : ''}
                              </div>
                            )}
                          </CustomCell>
                          <CustomCell>
                            <center>
                              <ConvertBtn
                                t={t}
                                item={item}
                                onClick={() => this.downloadImagesSet(item.order_id, item.order_no)}
                                convertingArray={this.state.convertingArray}
                                downloadingArray={this.state.downloadingArray}
                                is_VirtualAccount_purchuage={
                                  item.pay_detail_method === '가상계좌' && item.pay_status !== 1
                                }
                              />
                              {/* <DItemDowndloadMobile onClick={() => this.downloadImagesSet(item.order_id)}>
                                {t('download')}
                              </DItemDowndloadMobile> */}
                            </center>
                          </CustomCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={{ padding: 0, border: 'none' }} colSpan={4}>
                            <Collapse in={item.ditemopen} timeout="auto">
                              {item.order_products.map((order, j) => (
                                <DetailItem
                                  key={j}
                                  style={{
                                    borderBottom: 'none',
                                    border: 'none',
                                    padding: 0,
                                    display: tabindex === 0 && order.refund_status !== 0 && 'none',
                                  }}
                                >
                                  <CustomCell
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      width: this.state.checkboxRefWidth,
                                    }}
                                  >
                                    <div>
                                      {tabindex === 0 && (
                                        <CheckBox
                                          onClick={() => this.onCheckItem(item.order_id, order.idx)}
                                          // style={{ margin: '10px 15px 10px 0px' }}
                                          key={j}
                                        >
                                          <CheckMark checked={checkboxArray.includes(order.idx)} />
                                        </CheckBox>
                                      )}
                                    </div>
                                  </CustomCell>
                                  <CustomCell
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      padding: '10px 0px 10px 0px',
                                      width: this.state.invoiceDetailWidth + this.state.orderAmountRefWidth,
                                    }}
                                  >
                                    <Link to={`/generate/result/detail/${order.product_id}`}>
                                      <Ratio
                                        ratio={1}
                                        style={{
                                          width: 60,
                                          backgroundColor: '#cccccc',
                                          backgroundImage: `url(${order.ai_generate.res_thumb_path})`,
                                          backgroundSize: 'cover',
                                        }}
                                      />
                                    </Link>
                                    <HorizontalSp sp={'1.1vw'} style={{ minWidth: 10, maxWidth: 20 }} />
                                    {item.pay_detail_method === '가상계좌' && item.pay_status !== 1 ? (
                                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        {item.payment_info &&
                                          (() => {
                                            const paymentInfo = JSON.parse(item.payment_info);
                                            const virtualAccount = paymentInfo.virtualAccount || {};
                                            return (
                                              <>
                                                <Link
                                                  to={`/generate/result/detail/${order.product_id}`}
                                                  style={{
                                                    textDecoration: 'none',
                                                    color: 'black',
                                                    fontSize: 12,
                                                    whiteSpace: 'nowrap',
                                                  }}
                                                >
                                                  {order.ai_generate.img_name}
                                                </Link>
                                                <DItemText style={{ color: '#686868', fontSize: 12, mixWidth: 135 }}>
                                                  상태: {t('deposit_pending')}
                                                </DItemText>
                                                <DItemText style={{ color: '#686868', fontSize: 12, mixWidth: 135 }}>
                                                  {banks[virtualAccount.bankCode]}:{' '}
                                                  {virtualAccount.accountNumber || 'N/A'}
                                                </DItemText>
                                                {this.state.invoiceDetailWidth > 135 && (
                                                  <DItemText style={{ color: '#686868', fontSize: 12, mixWidth: 135 }}>
                                                    입금 기한일:{' '}
                                                    {virtualAccount.dueDate
                                                      ? virtualAccount.dueDate.substring(0, 16).replace(/-/g, '.')
                                                      : 'N/A'}
                                                  </DItemText>
                                                )}
                                              </>
                                            );
                                          })()}
                                      </div>
                                    ) : (
                                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <DItemTitle>
                                          <Link
                                            to={`/generate/result/detail/${order.product_id}`}
                                            style={{
                                              textDecoration: 'none',
                                              color: 'black',
                                              fontSize: 12,
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            {order.ai_generate.img_name}
                                          </Link>
                                        </DItemTitle>
                                        <DItemText style={{ color: '#686868', fontSize: 12, mixWidth: 135 }}>
                                          {`Classic (${t('exclusive')})`}
                                        </DItemText>
                                        {(order.is_download && order.product_download_datetime) ||
                                        moment(order.order_datetime).add(7, 'days') < moment() ? (
                                          <DItemDowndTxt style={{ fontSize: 13, color: 'green', textAlign: 'left' }}>
                                            {t('order_approved')}
                                          </DItemDowndTxt>
                                        ) : (
                                          <DItemDowndTxt style={{ fontSize: 13, color: '#686868', textAlign: 'left' }}>
                                            {t('order_pending')}
                                          </DItemDowndTxt>
                                        )}
                                      </div>
                                    )}
                                  </CustomCell>
                                  <CustomCell style={{ padding: 10, flex: 1 }}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <DItemCostMobile style={{ fontSize: 12, marginBottom: 5 }}>
                                        {item.pay_method === 'credit' ? (
                                          <>1 {t('credit')} </>
                                        ) : (
                                          <>
                                            {item.pay_currency === 'KRW'
                                              ? '₩'
                                              : item.pay_currency === 'USD'
                                              ? '$'
                                              : item.pay_currency === 'EUR'
                                              ? '€'
                                              : ''}
                                            {item.pay_total_amount.toLocaleString()}
                                          </>
                                        )}
                                      </DItemCostMobile>
                                      {tabindex === 1 && (
                                        <DItemText style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: '#999999' }}>
                                          {order.refund_status === 1
                                            ? t('under_refund')
                                            : order.refund_status === 3
                                            ? t('refund_is_completed')
                                            : ''}
                                        </DItemText>
                                      )}

                                      {tabindex === 0 && (
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                          <div style={{ position: 'relative' }}>
                                            <ConvertBtnEach
                                              t={t}
                                              item={order}
                                              onClick={() =>
                                                this.downloadImageOne(order.product_id, order.ai_generate.img_name)
                                              }
                                              convertingArray={this.state.convertingArray}
                                              downloadingArray={this.state.downloadingArray}
                                              is_VirtualAccount_purchuage={
                                                item.pay_detail_method === '가상계좌' && item.pay_status !== 1
                                              }
                                            />
                                            {/* <DItemDowndloadMobile onClick={() => this.downloadImageOne(order.product_id)}>
                                              {t('download')}
                                            </DItemDowndloadMobile> */}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </CustomCell>
                                </DetailItem>
                              ))}
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </>
                    ))}
                    {list.length === 0 && (
                      <TableRow>
                        <TableCell align="center" colSpan={6}>
                          <GoodCell style={{ fontFamily: 'NSCJKrB', width: isMobile ? 'max-content' : 'auto' }}>
                            {t('no_data')}
                          </GoodCell>
                        </TableCell>
                      </TableRow>
                    )}
                  </CustomBody>
                </Table>
                <VerticalSp sp={'2.2vw'} style={{ maxHeight: 40, minHeight: 20 }} />
              </TableContainer>
            </>
          ) : (
            <>
              {/* ==============================================================================================================================모바일화면 -> 환불내역 */}
              <TableContainer>
                <Table>
                  <CustomHead>
                    <TableRow>
                      <TableCell style={{ width: 20 }} ref={(checkbox_ref) => (this.checkbox_ref = checkbox_ref)}>
                        <HeadCell style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>{''}</HeadCell>
                      </TableCell>
                      <TableCell
                        style={{ padding: 0 }}
                        align="flex-start"
                        ref={(invoice_detail_ref) => (this.invoice_detail_ref = invoice_detail_ref)}
                      >
                        <HeadCell>{t('invoice_detail')}</HeadCell>
                      </TableCell>
                      <TableCell
                        style={{ padding: 10 }}
                        align="center"
                        ref={(order_amount_ref) => (this.order_amount_ref = order_amount_ref)}
                      >
                        <HeadCell>{t('order_amount')}</HeadCell>
                      </TableCell>
                      <TableCell
                        style={{ padding: 0 }}
                        align="center"
                        ref={(design_file_ref) => (this.design_file_ref = design_file_ref)}
                      >
                        <HeadCell>{t('refund_status')}</HeadCell>
                      </TableCell>
                    </TableRow>
                  </CustomHead>
                  <CustomBody>
                    {list.map((item, index) => (
                      <>
                        <TableRow key={`list-${index}`}>
                          <CustomCell style={{ width: 18 }}>
                            <CheckBox
                              onClick={() => this.onCheckItemList(item.order_id)}
                              style={{ marginBottom: 8, width: 18 }}
                              key={item.order_id}
                            >
                              <CheckMark checked={checkboxListArray.includes(item.order_id)} />
                            </CheckBox>
                          </CustomCell>
                          <CustomCell style={{ padding: 0 }} align="left">
                            {item.order_products.length > 0 && (
                              <BodyCell
                                style={{
                                  fontFamily: 'NSCJKrB',
                                  fontSize: 12,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'flex-start',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  this.showProductList(index);
                                }}
                              >
                                <div>
                                  <span>{`${item.order_no?.substring(0, 8)}`}</span>
                                  <span style={{ color: '#999999' }}>&nbsp;{`(+${item.order_products.length})`}</span>
                                </div>
                                <div>
                                  <span
                                    style={{ fontFamily: 'NSCJKrR', fontSize: 10, color: '#999999' }}
                                  >{`${item.order_datetime.substring(0, 16).replace(/-/gi, '.')}`}</span>
                                  <img
                                    alt=""
                                    src={ditemopen ? images.icon_collapse : images.icon_expend}
                                    style={{ marginLeft: 8 }}
                                  />
                                </div>
                              </BodyCell>
                            )}
                          </CustomCell>
                          <CustomCell style={{ padding: 0, width: 80, justifyContent: 'center' }} align="center">
                            <div style={{ fontFamily: 'NSCJKrR', fontSize: 12, color: '#999999', marginBottom: 5 }}>
                              {item.refund_status === 1
                                ? t('under_refund')
                                : item.refund_status === 3
                                ? t('refund_is_completed')
                                : ''}
                            </div>
                            <BodyCell style={{ fontFamily: 'NSCJKrB', justifyContent: 'center', fontSize: 12 }}>
                              <div>
                                <DItemCostMobile style={{ marginBottom: 5 }}>
                                  {item.pay_method === 'credit' ? (
                                    <>1 {t('credit')} </>
                                  ) : (
                                    <>
                                      {item.pay_currency === 'KRW'
                                        ? '₩'
                                        : item.pay_currency === 'USD'
                                        ? '$'
                                        : item.pay_currency === 'EUR'
                                        ? '€'
                                        : ''}
                                      {item.pay_total_amount.toLocaleString()}
                                    </>
                                  )}
                                </DItemCostMobile>
                                <ReceiptBtnMobile
                                  onClick={() => {
                                    this.setState({ receiptmodal: true, receiptTarget: index });
                                  }}
                                >
                                  {t('view_invoice')}
                                </ReceiptBtnMobile>
                              </div>
                            </BodyCell>
                          </CustomCell>
                          <CustomCell style={{ fontFamily: 'NSCJKrB', justifyContent: 'center', fontSize: 12 }}>
                            <center>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ color: '#36792B' }}>
                                  {t('under_refund')}:{' '}
                                  {item.order_products.filter((product) => product.refund_status === 1).length}
                                </span>
                                <VerticalSp sp={5} />
                                <span style={{ color: '#FF8A06' }}>
                                  {t('refund_is_completed')}:{' '}
                                  {item.order_products.filter((product) => product.refund_status === 3).length}
                                </span>
                              </div>
                            </center>
                          </CustomCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={{ padding: 0, border: 0 }} colSpan={4}>
                            <Collapse in={item.ditemopen} timeout="auto">
                              {item.order_products.map((order, j) => (
                                <DetailItem
                                  key={j}
                                  style={{
                                    paddingLeft:
                                      tabindex === 0 &&
                                      (order.is_download || moment(order.order_datetime).add(7, 'days') < moment())
                                        ? ''
                                        : '',
                                    display: tabindex === 0 && order.refund_status !== 0 && 'none',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      width:
                                        this.state.checkboxRefWidth +
                                        this.state.invoiceDetailWidth +
                                        this.state.orderAmountRefWidth -
                                        10,
                                    }}
                                  >
                                    <Ratio
                                      ratio={1}
                                      style={{
                                        width: 60,
                                        backgroundColor: '#cccccc',
                                        backgroundImage: `url(${order.ai_generate.res_thumb_path})`,
                                        backgroundSize: 'cover',
                                      }}
                                    />
                                    <HorizontalSp sp={'1.1vw'} style={{ minWidth: 10, maxWidth: 20 }} />
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                      <DItemTitle style={{ fontSize: 12 }}>{order.ai_generate.img_name}</DItemTitle>
                                      <DItemText style={{ color: '#686868', fontSize: 12 }}>
                                        {`Classic (${t('exclusive')})`}
                                      </DItemText>
                                      <DItemTitle style={{ fontSize: 12 }}>
                                        {item.pay_method === 'credit' ? (
                                          <>1 {t('credit')} </>
                                        ) : (
                                          <>
                                            {item.pay_currency === 'KRW'
                                              ? '₩'
                                              : item.pay_currency === 'USD'
                                              ? '$'
                                              : item.pay_currency === 'EUR'
                                              ? '€'
                                              : ''}
                                            {item.pay_total_amount.toLocaleString()}
                                          </>
                                        )}
                                      </DItemTitle>
                                    </div>
                                  </div>
                                  <DItemText
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      fontFamily: 'NSCJKrR',
                                      fontSize: 14,
                                      whiteSpace: 'nowrap',
                                      color: order.refund_status === 1 ? '#36792B' : '#FF8A06',
                                      width: this.state.designFileWidth - 20,
                                      paddingLeft: 10,
                                    }}
                                  >
                                    {order.refund_status === 1
                                      ? t('under_refund')
                                      : order.refund_status === 3
                                      ? t('refund_is_completed')
                                      : ''}
                                  </DItemText>
                                </DetailItem>
                              ))}
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </>
                    ))}
                    {list.length === 0 && (
                      <TableRow>
                        <TableCell align="center" colSpan={6}>
                          <GoodCell style={{ fontFamily: 'NSCJKrB', width: isMobile ? 'max-content' : 'auto' }}>
                            {t('no_data')}
                          </GoodCell>
                        </TableCell>
                      </TableRow>
                    )}
                  </CustomBody>
                </Table>
                <VerticalSp sp={'2.2vw'} style={{ maxHeight: 40, minHeight: 20 }} />
              </TableContainer>
            </>
          )}
        </MediaQuery>
        <VerticalSp sp={'1.4vw'} style={{ maxHeight: 25, minHeight: 13 }} />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Pagenation page={page} total_pages={total_pages} getList={this.getList} />
        </div>
        <VerticalSp sp={'4.2vw'} style={{ maxHeight: 76, minHeight: 38 }} />

        <ChoiseFileModal
          show={this.state.downloadFileChoiceModalState}
          onClose={this.onCloseDownloadFileChoiceModal}
          onDownloadFileChoice={this.onDownloadFileChoice}
        />
        {/* 영수증 modal */}
        <Modal
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, overflow: 'auto' }}
          open={receiptmodal}
          onClose={this.onCloseReceiptModal}
        >
          <Fade in={receiptmodal}>
            <ModalContents
              style={{ height: '85vh', width: getBigModalWidh(), overflow: 'auto' }}
              onClose={this.onCloseReceiptModal}
            >
              <section style={{ overflow: 'auto', backgroundColor: 'white', margin: isMobile ? 10 : 20 }}>
                <ModalTitle>{t('invoice')}</ModalTitle>
                <HSLine bgcolor="#eeeeee" />
                <div style={{ margin: isMobile ? 10 : 20 }}>
                  <ModalPurTitle>TEXTILE DESIGN BANK</ModalPurTitle>
                  <div style={{ overflow: 'auto' }}>
                    <VerticalSp sp={'1.6vw'} style={{ maxHeight: 30, minHeight: 15 }} />
                    <ReceiptDesItem label={`${t('invoice_no')} #`}>
                      <div style={{ fontFamily: 'NSCJKrB' }}>{list[receiptTarget] && list[receiptTarget].order_no}</div>
                    </ReceiptDesItem>
                    <ReceiptDesItem label={t('date_of_invoice')}>
                      <div>
                        {list[receiptTarget] && list[receiptTarget].order_datetime.substring(0, 16).replace(/-/gi, '.')}
                      </div>
                    </ReceiptDesItem>
                    <ReceiptDesItem label={t('invoice_to')}>
                      <div>
                        {t('buyer_name')} {list[receiptTarget] && list[receiptTarget].user.name}│{t('company_name')}{' '}
                        {list[receiptTarget] && list[receiptTarget].user.company
                          ? list[receiptTarget].user.company
                          : '-'}
                      </div>
                    </ReceiptDesItem>
                    <ReceiptDesItem label={t('invoice_from')}>
                      <div>{t('textileDesignBank')}│720-88-02717</div>
                    </ReceiptDesItem>
                    <ReceiptDesItem label={t('order_status')}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {list[receiptTarget] && list[receiptTarget].order_status === 0
                          ? t('order_pending')
                          : list[receiptTarget] && list[receiptTarget].order_status === 1
                          ? t('order_approved')
                          : ''}
                        <PdfDownBtn
                          onClick={() => {
                            this.downloadReceipt(list[receiptTarget].order_id);
                          }}
                        >
                          {t('download_invoice_pdf')}
                        </PdfDownBtn>
                      </div>
                    </ReceiptDesItem>
                    <VerticalSp sp={'1vw'} style={{ maxHeight: 16, minHeight: 8 }} />
                  </div>
                  {/* 주문 내역 */}
                  <ModalBlockLbl>{t('your_invoice')}</ModalBlockLbl>
                  <VerticalSp sp={'1vw'} style={{ maxHeight: 16, minHeight: 8 }} />
                  <TableContainer>
                    <Table>
                      <ModalHead>
                        <TableRow>
                          <ModalCell align="center" style={{ padding: isMobile ? 5 : 10 }}>
                            <ModalHisCell style={{ width: 'max-content' }}>{t('no')}</ModalHisCell>
                          </ModalCell>
                          <ModalCell style={{ padding: isMobile ? 5 : 10 }}>
                            <ModalHisCell style={{ width: 'max-content' }}>{t('product_name')}</ModalHisCell>
                          </ModalCell>
                          <ModalCell align="center" style={{ padding: isMobile ? 5 : 10 }}>
                            <ModalHisCell>{getStringByLang('수량', 'Quantity', '数量')}</ModalHisCell>
                          </ModalCell>
                          <ModalCell align="center" style={{ padding: isMobile ? 5 : 10 }}>
                            <ModalHisCell>
                              {`${t('price')} ${getCurrencySymbol(list[receiptTarget]?.pay_currency)}`}
                            </ModalHisCell>
                          </ModalCell>
                        </TableRow>
                      </ModalHead>
                      <ModalBody>
                        {list[receiptTarget] &&
                          list[receiptTarget].order_products.map((item, index) => (
                            <TableRow key={index}>
                              <ModalCell align="center" style={{ padding: isMobile ? 5 : 10 }}>
                                <ModalHisCell>{index + 1}</ModalHisCell>
                              </ModalCell>
                              <ModalCell style={{ padding: isMobile ? 5 : 10 }}>
                                <ModalHisCell style={{ fontFamily: 'NSCJKrM', width: 'max-content', maxWidth: 450 }}>
                                  {item.ai_generate.img_name}
                                </ModalHisCell>
                              </ModalCell>
                              <ModalCell align="center" style={{ padding: isMobile ? 5 : 10 }}>
                                <ModalHisCell>1</ModalHisCell>
                              </ModalCell>
                              <ModalCell align="center" style={{ padding: isMobile ? 5 : 10 }}>
                                <ModalHisCell>
                                  {item.pay_currency === 'KRW'
                                    ? '₩'
                                    : item.pay_currency === 'USD'
                                    ? '$'
                                    : item.pay_currency === 'EUR'
                                    ? '€'
                                    : ''}
                                  {item.product_amount.toLocaleString()}
                                </ModalHisCell>
                              </ModalCell>
                            </TableRow>
                          ))}
                      </ModalBody>
                    </Table>
                  </TableContainer>
                  <VerticalSp sp={'0.8vw'} style={{ maxHeight: 16, minHeight: 8 }} />
                  <ModalBlockLbl>{t('total')}</ModalBlockLbl>
                  <VerticalSp sp={'1vw'} style={{ maxHeight: 16, minHeight: 8 }} />
                  <div
                    style={{
                      borderTop: '1px solid #dddddd',
                      borderBottom: '1px solid #dddddd',
                      backgroundColor: '#fafafa',
                      height: 78,
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {/* 총 상품가격 */}
                    {list[receiptTarget] && list[receiptTarget].pay_method === 'credit' ? (
                      ''
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <HorizontalSp sp={24} />
                        <div style={{ fontFamily: 'NSCJKrR', fontSize: 12, color: 'black' }}>{`${t(
                          'lsit_price',
                        )} : `}</div>
                        <div style={{ flex: 1 }} />
                        <div style={{ fontFamily: 'NSCJKrB', fontSize: 12, color: 'black' }}>
                          {list[receiptTarget] && list[receiptTarget].pay_currency === 'KRW'
                            ? '₩'
                            : list[receiptTarget] && list[receiptTarget].pay_currency === 'USD'
                            ? '$'
                            : list[receiptTarget] && list[receiptTarget].pay_currency === 'EUR'
                            ? '€'
                            : ''}
                          {list[receiptTarget] && this.getOriginPrice(list[receiptTarget])?.originPrice}
                        </div>
                        <HorizontalSp sp={24} />
                      </div>
                    )}
                    {/* 할인 */}
                    {!(list[receiptTarget] && list[receiptTarget].pay_method === 'credit') &&
                      list[receiptTarget]?.order_products[0].product_amount !==
                        list[receiptTarget]?.pay_total_amount && (
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                          <HorizontalSp sp={24} />
                          <div style={{ fontFamily: 'NSCJKrR', fontSize: 12, color: 'black' }}>
                            {`${t('discount_price')} (${
                              list[receiptTarget] && this.getOriginPrice(list[receiptTarget])?.discountValue
                            } %) : `}
                          </div>
                          <div style={{ flex: 1 }} />
                          <div style={{ fontFamily: 'NSCJKrB', fontSize: 12, color: 'black' }}>
                            -{' '}
                            {list[receiptTarget] && list[receiptTarget].pay_currency === 'KRW'
                              ? '₩'
                              : list[receiptTarget] && list[receiptTarget].pay_currency === 'USD'
                              ? '$'
                              : list[receiptTarget] && list[receiptTarget].pay_currency === 'EUR'
                              ? '€'
                              : ''}
                            {list[receiptTarget] && this.getOriginPrice(list[receiptTarget])?.discountAmount}
                          </div>
                          <HorizontalSp sp={24} />
                        </div>
                      )}

                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <HorizontalSp sp={24} />
                      <div style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: 'black' }}>{t('total')}</div>
                      <div style={{ flex: 1 }} />

                      <div style={{ fontFamily: 'NSCJKrB', fontSize: 14, color: 'black' }}>
                        {list[receiptTarget] && list[receiptTarget].pay_method === 'credit'
                          ? `${list[receiptTarget].use_credit} ${t('credit')}`
                          : list[receiptTarget] && list[receiptTarget].pay_currency === 'KRW'
                          ? '₩'
                          : list[receiptTarget] && list[receiptTarget].pay_currency === 'USD'
                          ? '$'
                          : list[receiptTarget] && list[receiptTarget].pay_currency === 'EUR'
                          ? '€'
                          : ''}
                        {list[receiptTarget] && this.getOriginPrice(list[receiptTarget])?.totalPrice}
                      </div>
                      <HorizontalSp sp={24} />
                    </div>
                  </div>
                  <VerticalSp sp={'0.8vw'} style={{ maxHeight: 16, minHeight: 8 }} />
                  <ModalBlockLbl>{t('paymentKind')}</ModalBlockLbl>
                  <VerticalSp sp={'1vw'} style={{ maxHeight: 16, minHeight: 8 }} />
                  <div
                    style={{
                      borderTop: '1px solid #dddddd',
                      borderBottom: '1px solid #dddddd',
                      backgroundColor: '#fafafa',
                      height: 47,
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {/* 영수증 보기 모달 - Payment 부분:  카드 결제 or 페이팔결제 or 크레딧*/}
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      {/* 한국어 */}
                      <div style={{ flex: 1 }} />
                      {/* ✅ 수정된 부분 3: 영수증 결제 방식 텍스트 */}
                      <div style={{ fontFamily: 'NSCJKrB', fontSize: 16, color: 'black' }}>
                        {list[receiptTarget] && this.getPaymentMethodText(list[receiptTarget].pay_method, lang)}
                      </div>
                      <HorizontalSp sp={24} />
                    </div>
                  </div>
                </div>
                {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ModalNorBtn onClick={this.onCloseReceiptModal} style={{ backgroundColor: '#ff8a06' }}>
                  {t('confirm')}
                </ModalNorBtn>
              </div> */}
              </section>
            </ModalContents>
          </Fade>
        </Modal>

        {/* 환불 요청 modal */}
        <Modal
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
          open={refundmodal}
          onClose={this.onCloseRefundModal}
        >
          <Fade in={refundmodal}>
            <ModalContents style={{ width: getModalWidh(), padding: 20 }} onClose={this.onCloseRefundModal}>
              <ModalTitle>{t('refund_application')}</ModalTitle>
              <HSLine bgcolor="#eeeeee" />
              <VerticalSp sp={'1.5vw'} style={{ maxHeight: 28, minHeight: 14 }} />
              {translationData.refundInfo[lang]}
              <VerticalSp sp={'0.6vw'} style={{ maxHeight: 10, minHeight: 5 }} />
              <div style={{ fontFamily: 'NSCJKrB', fontSize: 16, color: 'black', textAlign: 'center' }}>
                textiledesignbank@gmail.com
              </div>
              <VerticalSp sp={'1.6vw'} style={{ maxHeight: 30, minHeight: 15 }} />
              <InputGroup>
                <InputPad>
                  <CustomeSelect
                    disableUnderline={true}
                    value={reasontype}
                    onChange={(event) => {
                      this.setState({ reasontype: event.target.value });
                    }}
                    style={{ width: '100%', borderBottom: 0 }}
                  >
                    <option value="">{t('select_refund_reason')}</option>
                    <option value="단순변심">{t('simple_change_of_mind')}</option>
                    <option value="다른 디자인 구매">{t('purchase_other_designs')}</option>
                    <option value="가격">{t('price2')}</option>
                    <option value="기타">{t('others')}</option>
                  </CustomeSelect>
                </InputPad>
              </InputGroup>
              <VerticalSp sp={'1.1vw'} style={{ maxHeight: 20, minHeight: 10 }} />
              <TextField
                placeholder={t('enter_refund_reason')}
                multiline
                rows={6}
                value={reasontxt}
                onChange={(event) => {
                  this.setState({ reasontxt: event.target.value });
                }}
                variant="outlined"
                InputProps={{ style: { ...inputStyle, fontSize: 16 } }}
                style={{ width: '100%' }}
              />
              <VerticalSp sp={'1.4vw'} style={{ maxHeight: 26, minHeight: 13 }} />
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ModalNorBtn onClick={this.onCloseRefundModal} style={{ backgroundColor: '#cccccc' }}>
                  {t('cancel')}
                </ModalNorBtn>
                <HorizontalSp sp={10} />
                <ModalNorBtn onClick={this.reqRefund} style={{ backgroundColor: '#ff8a06' }}>
                  {t('confirm')}
                </ModalNorBtn>
              </div>
            </ModalContents>
          </Fade>
        </Modal>
      </div>
    );
  }
}
export default withTranslation()(GeneratePurchaseList);
